export var FlowRunBlockDataSourceType;
(function (FlowRunBlockDataSourceType) {
    FlowRunBlockDataSourceType["Empty"] = "Empty";
    FlowRunBlockDataSourceType["Inherited"] = "Inherited";
    FlowRunBlockDataSourceType["Mocked"] = "Mocked";
})(FlowRunBlockDataSourceType || (FlowRunBlockDataSourceType = {}));
//# sourceMappingURL=runBlockDataSource.js.map